export default "__VITE_ASSET__CDBqiWVa__"